import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import styles from '../styles/sidebar.module.css';

function Sidebar({onCategoryChange}) {
  
  
  return (
    <Navbar expand="lg" >
      <Container className={styles['sidebar']}>
          <Nav className={styles['sidebar-links']}>
            <Nav.Link onClick={() => onCategoryChange('popular')}>Popular</Nav.Link>
            <Nav.Link  onClick={() => onCategoryChange('top_rated')}>Top Rated</Nav.Link>
            <Nav.Link  onClick={() => onCategoryChange('now_playing')}>Now Playing</Nav.Link>
            <Nav.Link onClick={() => onCategoryChange('trending')}>Trending</Nav.Link>
            <Nav.Link onClick={() => onCategoryChange('horror')}>Horror</Nav.Link>
            <Nav.Link onClick={() => onCategoryChange('action')}>Action</Nav.Link>
            <Nav.Link  onClick={() => onCategoryChange('crime')}>Crime</Nav.Link>
            <Nav.Link onClick={() => onCategoryChange('comedy')}>Comedy</Nav.Link>
            <Nav.Link onClick={() => onCategoryChange('drama')}>Drama</Nav.Link>
            <Nav.Link onClick={() => onCategoryChange('adventure')}>Adventure</Nav.Link>
          </Nav>
      </Container>
    </Navbar>
  );
}

export default Sidebar;